export default __webpack_public_path__ + "static/media/lake-view.313819b8.png";